import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IN_ROOM_DINING_TAGS_EDIT } from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { inRoomDiningTagsSelector } from '../../../servicesSlice';
import InRoomDiningTagViewDetail from './Tag-View-Details';

const InRoomDiningTagView = (props) => {
  const { tag, toggleDrawer, onViewToggle, permissions } = props;
  const inRoomDiningTag = useSelector(inRoomDiningTagsSelector);
  const [tabValue, setTabValue] = useState(0);
  const [currTag, setCurrTag] = useState(null);

  useEffect(() => {
    if (inRoomDiningTag.length) {
      let ragObj = { ...inRoomDiningTag.find((temp) => temp.id === tag.id) };
      setCurrTag(ragObj);
    }
  }, [inRoomDiningTag]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, currTag);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(IN_ROOM_DINING_TAGS_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <InRoomDiningTagViewDetail tabValue={tabValue} tag={currTag} />;
  };

  return (
    <>
      {currTag && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          onViewToggle={onViewToggle}
          title={currTag.name}
          createdUserId={currTag.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default InRoomDiningTagView;
